// get_workspace_categories
export const GET_WORKSPACE_CATEGORIES = 'get_workspace_categories';
export const GET_WORKSPACE_CATEGORIES_SUCCESSFUL =
  'get_workspace_categories_successfull';
export const GET_WORKSPACE_CATEGORIES_FAILED =
  'get_workspace_categories_failed';

// create_workspace_category
export const CREATE_WORKSPACE_CATEGORY = 'create_workspace_category';
export const CREATE_WORKSPACE_CATEGORY_SUCCESSFUL =
  'create_workspace_category_successfull';
export const CREATE_WORKSPACE_CATEGORY_FAILED =
  'create_workspace_category_failed';

// update_workspace_category
export const UPDATE_WORKSPACE_CATEGORY = 'update_workspace_category';
export const UPDATE_WORKSPACE_CATEGORY_SUCCESSFUL =
  'update_workspace_category_successfull';
export const UPDATE_WORKSPACE_CATEGORY_FAILED =
  'update_workspace_category_failed';

// delete_workspace_category
export const DELETE_WORKSPACE_CATEGORY = 'delete_workspace_category';
export const DELETE_WORKSPACE_CATEGORY_SUCCESSFUL =
  'delete_workspace_category_successfull';
export const DELETE_WORKSPACE_CATEGORY_FAILED =
  'delete_workspace_category_failed';
